export const EVENT_TOPIC_SUGGESTIONS = [
  'Startups',
  'Technology',
  'Networking',
  'Entrepreneurship',
  'AI',
  'FinTech',
  'Founders',
  'Investing',
];

export const EVENT_TOPICS_MAX = 10;

export const normalizeTopicInput = (value) =>
  String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ');

export const normalizeTopicsFromApi = (value) => {
  if (!value) return [];

  const list = Array.isArray(value) ? value : [];

  return list
    .map((item) => (typeof item === 'string' ? item : (item?.name ?? item?.label ?? '')))
    .map(normalizeTopicInput)
    .filter(Boolean)
    .filter(
      (topic, index, topics) =>
        topics.findIndex((entry) => entry.toLowerCase() === topic.toLowerCase()) === index,
    );
};

export const addTopicToList = (topics, nextTopic) => {
  const normalized = normalizeTopicInput(nextTopic);
  if (!normalized) return topics;

  const exists = topics.some((topic) => topic.toLowerCase() === normalized.toLowerCase());
  if (exists || topics.length >= EVENT_TOPICS_MAX) {
    return topics;
  }

  return [...topics, normalized];
};

export const removeTopicFromList = (topics, topicToRemove) =>
  topics.filter((topic) => topic !== topicToRemove);

/** API expects a JSON array of topic strings, e.g. ["Networking", "Wellness", "AI"]. */
export const formatTopicsForApi = (topics) => normalizeTopicsFromApi(topics);
